/* Asfar Al-Ummah — site behaviour v3 (NL / AR / EN / FR) */
(function () {
  "use strict";

  var STORAGE_KEY = "asfar-lang";
  var LANGS = ["nl", "ar", "en", "fr"];
  var LANG_NAMES = { nl: "Nederlands", ar: "العربية", en: "English", fr: "Français" };
  var htmlEl = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- language ---------- */
  function buildDesktopSwitcher() {
    var old = document.querySelector(".lang-toggle");
    if (!old || document.getElementById("langSwitch")) return;
    var wrap = document.createElement("div");
    wrap.className = "lang-switch";
    wrap.id = "langSwitch";
    wrap.innerHTML =
      '<button type="button" class="lang-toggle-btn" id="langToggleBtn" aria-haspopup="true" aria-expanded="false" aria-label="Taal / Language">' +
      '<svg class="globe" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>' +
      '<span id="langCurrent">NL</span>' +
      '<svg class="chev" viewBox="0 0 12 8"><path d="M1 1l5 5 5-5"/></svg></button>' +
      '<div class="lang-menu" id="langMenu" role="menu"></div>';
    var menu = wrap.querySelector("#langMenu");
    LANGS.forEach(function (code) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("role", "menuitem");
      b.setAttribute("data-setlang", code);
      b.innerHTML = "<span>" + LANG_NAMES[code] + '</span><span class="code">' + code + "</span>";
      menu.appendChild(b);
    });
    old.replaceWith(wrap);
  }

  function buildMobileSwitcher() {
    var host = document.getElementById("mnLang") || document.getElementById("mobileNav");
    if (!host || document.querySelector(".mobile-lang")) return;
    var wrap = document.createElement("div");
    wrap.className = "mobile-lang";
    LANGS.forEach(function (code) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("data-setlang", code);
      b.textContent = LANG_NAMES[code];
      wrap.appendChild(b);
    });
    host.appendChild(wrap);
  }

  function getSavedLang() {
    try { var v = localStorage.getItem(STORAGE_KEY); return LANGS.indexOf(v) > -1 ? v : null; } catch (e) { return null; }
  }
  function saveLang(lang) { try { localStorage.setItem(STORAGE_KEY, lang); } catch (e) {} }

  function applyLang(lang) {
    if (LANGS.indexOf(lang) === -1) lang = "nl";
    document.querySelectorAll(".i18n").forEach(function (el) {
      var val = el.getAttribute("data-" + lang);
      if (val === null) val = el.getAttribute("data-nl");
      if (val !== null) el.textContent = val;
    });
    document.querySelectorAll("[data-i18n-aria-nl]").forEach(function (el) {
      var v = el.getAttribute("data-i18n-aria-" + lang) || el.getAttribute("data-i18n-aria-nl");
      el.setAttribute("aria-label", v);
    });
    htmlEl.setAttribute("lang", lang);
    htmlEl.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    htmlEl.setAttribute("data-lang", lang);
    document.querySelectorAll("[data-setlang]").forEach(function (b) {
      b.classList.toggle("active", b.getAttribute("data-setlang") === lang);
    });
    var trigger = document.getElementById("langCurrent");
    if (trigger) trigger.textContent = lang.toUpperCase();
    saveLang(lang);
    document.dispatchEvent(new CustomEvent("asfar:langchange", { detail: { lang: lang } }));
  }

  function closeLangMenu() {
    var menu = document.getElementById("langMenu");
    var sw = document.getElementById("langSwitch");
    var btn = document.getElementById("langToggleBtn");
    if (menu) menu.classList.remove("open");
    if (sw) sw.classList.remove("open");
    if (btn) btn.setAttribute("aria-expanded", "false");
  }

  function initLang() {
    buildDesktopSwitcher();
    buildMobileSwitcher();
    applyLang(getSavedLang() || "nl");
    document.addEventListener("click", function (e) {
      var setBtn = e.target.closest ? e.target.closest("[data-setlang]") : null;
      if (setBtn) { applyLang(setBtn.getAttribute("data-setlang")); closeLangMenu(); return; }
      var toggle = e.target.closest ? e.target.closest("#langToggleBtn") : null;
      var menu = document.getElementById("langMenu");
      if (toggle && menu) {
        var open = !menu.classList.contains("open");
        menu.classList.toggle("open", open);
        document.getElementById("langSwitch").classList.toggle("open", open);
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        return;
      }
      if (menu && !menu.contains(e.target)) closeLangMenu();
    });
  }

  /* ---------- header: transparent → glass ---------- */
  function initHeader() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle("scrolled", window.scrollY > 24);
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- mobile overlay menu ---------- */
  function initMobileNav() {
    var burger = document.getElementById("burgerBtn");
    var panel = document.getElementById("mobileNav");
    if (!burger || !panel) return;
    function setOpen(open) {
      panel.classList.toggle("open", open);
      burger.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      panel.setAttribute("aria-hidden", open ? "false" : "true");
      document.body.classList.toggle("nav-open", open);
      if (open) { var first = panel.querySelector("a"); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 250); }
    }
    burger.addEventListener("click", function () { setOpen(!panel.classList.contains("open")); });
    panel.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { setOpen(false); }); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { if (panel.classList.contains("open")) { setOpen(false); burger.focus(); } closeLangMenu(); }
    });
    window.addEventListener("resize", function () { if (window.innerWidth > 1180 && panel.classList.contains("open")) setOpen(false); });
  }

  /* ---------- scroll reveal ---------- */
  var revealObs = null;
  function initReveal() {
    var els = document.querySelectorAll(".reveal:not(.in)");
    if (!els.length) return;
    if (!("IntersectionObserver" in window) || reduceMotion) { els.forEach(function (el) { el.classList.add("in"); }); return; }
    if (!revealObs) {
      revealObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add("in"); revealObs.unobserve(entry.target); }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    }
    els.forEach(function (el) { revealObs.observe(el); });
  }

  /* ---------- journey steps (home) ---------- */
  function initJourney() {
    var steps = document.querySelectorAll(".j-step");
    if (!steps.length || !("IntersectionObserver" in window)) { steps.forEach(function (s) { s.classList.add("active"); }); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) entry.target.classList.add("active"); });
    }, { threshold: 0.5 });
    steps.forEach(function (s) { obs.observe(s); });
  }

  /* ---------- photos: data-src may hold "url1|url2" (first that loads wins) ---------- */
  function initPhotoPlaceholders() {
    document.querySelectorAll(".photo-ph[data-src]:not([data-loaded])").forEach(function (ph) {
      var list = (ph.getAttribute("data-src") || "").split("|").filter(Boolean);
      ph.setAttribute("data-loaded", "1");
      (function tryNext(i) {
        if (i >= list.length) return;
        var img = new Image();
        img.onload = function () {
          var real = document.createElement("img");
          real.src = list[i];
          real.alt = ph.getAttribute("data-alt") || "";
          real.className = "real";
          real.loading = "lazy";
          real.style.display = "block";
          ph.appendChild(real);
          ph.querySelectorAll("svg,span").forEach(function (n) { n.style.opacity = "0"; });
        };
        img.onerror = function () { tryNext(i + 1); };
        img.src = list[i];
      })(0);
    });
  }

  /* ---------- active nav link ---------- */
  function markActiveNav() {
    var path = window.location.pathname.replace(/\/$/, "");
    if (path === "/pages/pakket") path = "/pages/pakketten";
    document.querySelectorAll("nav.links a, .mobile-nav a").forEach(function (a) {
      var href = (a.getAttribute("href") || "").replace(/\/$/, "");
      if (href === path) a.classList.add("active");
    });
  }

  /* ---------- hero video ---------- */
  function initHeroVideo() {
    var v = document.querySelector(".hv-video");
    if (!v) return;
    if (reduceMotion) { try { v.pause(); } catch (e) {} v.removeAttribute("autoplay"); return; }
    v.muted = true;
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function () {});
    v.addEventListener("error", function () { v.style.display = "none"; }, true);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { try { v.pause(); } catch (e) {} } else { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
    });
  }

  /* ---------- slider ---------- */
  function initSliders() {
    document.querySelectorAll("[data-slider]").forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll(".slide"));
      if (!slides.length) return;
      var dotsWrap = root.querySelector(".slider-dots");
      var countEl = root.querySelector(".slider-count");
      var delay = parseInt(root.getAttribute("data-interval") || "6500", 10);
      root.style.setProperty("--slide-ms", delay + "ms");
      var index = 0, timer = null, paused = false;

      var dots = slides.map(function (s, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Slide " + (i + 1));
        b.innerHTML = "<i></i>";
        b.addEventListener("click", function () { go(i, true); });
        if (dotsWrap) dotsWrap.appendChild(b);
        return b;
      });

      function render() {
        slides.forEach(function (s, i) {
          var on = i === index;
          s.classList.toggle("is-active", on);
          s.setAttribute("aria-hidden", on ? "false" : "true");
          s.querySelectorAll("a,button").forEach(function (el) { el.tabIndex = on ? 0 : -1; });
        });
        dots.forEach(function (d, i) {
          d.classList.toggle("done", i < index);
          d.classList.remove("is-active");
          if (i === index) { void d.offsetWidth; d.classList.add("is-active"); }
          d.setAttribute("aria-current", i === index ? "true" : "false");
        });
        if (countEl) countEl.textContent = String(index + 1).padStart(2, "0") + " / " + String(slides.length).padStart(2, "0");
      }
      function go(i, user) {
        index = (i + slides.length) % slides.length;
        render();
        schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (paused || reduceMotion || slides.length < 2) return;
        timer = setTimeout(function () { go(index + 1); }, delay);
      }
      function setPaused(p) { paused = p; root.classList.toggle("paused", p); if (p) clearTimeout(timer); else schedule(); }

      var prev = root.querySelector("[data-prev]");
      var next = root.querySelector("[data-next]");
      var rtl = function () { return htmlEl.getAttribute("dir") === "rtl"; };
      if (prev) prev.addEventListener("click", function () { go(index - 1, true); });
      if (next) next.addEventListener("click", function () { go(index + 1, true); });
      root.addEventListener("mouseenter", function () { setPaused(true); });
      root.addEventListener("mouseleave", function () { setPaused(false); });
      root.addEventListener("focusin", function () { setPaused(true); });
      root.addEventListener("focusout", function () { setPaused(false); });
      root.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") go(index + (rtl() ? -1 : 1), true);
        if (e.key === "ArrowLeft") go(index + (rtl() ? 1 : -1), true);
      });
      document.addEventListener("visibilitychange", function () { setPaused(document.hidden); });

      var startX = null, startY = null;
      root.addEventListener("pointerdown", function (e) { startX = e.clientX; startY = e.clientY; });
      root.addEventListener("pointerup", function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          var forward = dx < 0;
          if (rtl()) forward = !forward;
          go(index + (forward ? 1 : -1), true);
        }
      });

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (!root.matches(":hover")) setPaused(!en.isIntersecting); });
        }, { threshold: 0.25 }).observe(root);
      }
      render();
      schedule();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initLang();
    initHeader();
    initMobileNav();
    initReveal();
    initJourney();
    initPhotoPlaceholders();
    markActiveNav();
    initHeroVideo();
    initSliders();
  });

  window.AsfarSite = { applyLang: applyLang, initPhotoPlaceholders: initPhotoPlaceholders, initReveal: initReveal, LANGS: LANGS };
})();
